import { render, staticRenderFns } from "./WhiteList.vue?vue&type=template&id=124509c4"
import script from "./WhiteList.vue?vue&type=script&lang=js"
export * from "./WhiteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports